module.exports = __webpack_public_path__ + "static/media/184.768eccad.jpg";